import React, { useEffect, useState } from "react";
import {
  Paper,
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import classes from "./location.module.css";
import { Checkbox, FormControlLabel, Box } from "@mui/material";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import Basic from "./DragAndDrop";
import { useDispatch, useSelector } from "react-redux";
import {
  authApi,
  authImageApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import {
  ADDRESS_BOOK,
  GET_USER,
  LOCATION,
  TEAM_MEMBERS_LIST,
  UPLOAD_IMAGE,
  MY_SUBS,
} from "../../../api-calls/api-urls";
import { useLocation, useNavigate } from "react-router-dom";
import {
  SaveAudio,
  saveLocationList,
} from "../../../Redux/actions/location-action";
import RecorderCard from "./audioRecorder";
import AssignLaterModel from "./AssignLaterModal";
import { getLanguagedataFunction } from "../../../utilities/language";
import {
  AboutusIcon,
  BrudCrumbBackIcon,
  BrudCrumbNextIcon,
} from "../../../components/Icons";
import AlertBox from "../../../components/AlertBox";
import AddressMapLoaction from "./AddressMapLoaction";
import { Numeric } from "../../../utilities/commonFunctions";
import moment from "moment";
import RepeatOptions from "./RepeatOptions";
import {
  defaultRepeatSettings,
  describeSettings,
  repeatStartDate,
  toRecurrencePayload,
  validateRepeatSettings,
} from "../../../utilities/recurrence";

const SubscriptionStatus = ({ teamMember, isSubscriptionExpired, teamSubscription, onRenew }) => {
  if (!teamMember) return null;

  const accentColor = isSubscriptionExpired ? "#c62828" : "#2e7d32";
  const bgColor = isSubscriptionExpired ? "#fdf3f3" : "#f1f8f1";
  const borderColor = isSubscriptionExpired ? "#ffcdd2" : "#c8e6c9";

  return (
    <Box
      sx={{
        mt: 1,
        px: 1.5,
        py: 1,
        borderRadius: 1.5,
        border: "1px solid",
        borderColor,
        borderLeft: `3px solid ${accentColor}`,
        backgroundColor: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: accentColor,
            flexShrink: 0,
          }}
        />
        <Typography variant="caption" sx={{ color: accentColor, fontWeight: 600 }}>
          {isSubscriptionExpired ? "Subscription Expired" : "Subscription Active"}
        </Typography>
        {!isSubscriptionExpired && teamSubscription?.end_date && (
          <Typography variant="caption" sx={{ color: "#6A6E8A" }}>
            &mdash; expires{" "}
            {new Date(teamSubscription.end_date).toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </Typography>
        )}
      </Box>
      {isSubscriptionExpired && (
        <Button
          size="small"
          variant="outlined"
          onClick={onRenew}
          sx={{
            borderColor: accentColor,
            color: accentColor,
            fontSize: "0.7rem",
            py: 0.25,
            px: 1,
            minWidth: "auto",
            lineHeight: 1.5,
            "&:hover": { backgroundColor: "#ffeaea", borderColor: accentColor },
          }}
        >
          Renew
        </Button>
      )}
    </Box>
  );
};

const CreateLocation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalToggle, setModalToggle] = useState(false);
  const [checked, setChecked] = useState();
  const [title, setTitle] = useState();
  const [teamMember, setTeamMember] = useState("");
  const [teamMemberName, setTeamMemberName] = useState();
  const [address, setAddress] = useState();
  const [discription, setDiscription] = useState();
  const [success, setSuccess] = useState(false);
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const [showAlert, setShowAlert] = useState(false);
  // Provenance of the address, when this assignment was started from an
  // address book entry. Sent as address_book_id so the entry's usage count
  // and usage history pick it up; null for a hand-typed location.
  const [addressBookId, setAddressBookId] = useState(null);
  const [mapLocation, setMapLocation] = useState();
  const [mobileNumber, setMobileNumber] = useState("");
  const [isMapScreen, setIsMapScreen] = useState(false);
  const [update, setUpdate] = useState();
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [teamMembersList, setTeamMembersList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState();
  const [editLocation, setEditLocation] = useState();
  const [images, setImages] = useState();
  const [loggedUser, setLoggedUser] = useState();
  let audioFile = useSelector((state) => state.location.audioList);
  const [audioFile1, setAudioFile1] = useState(null);
  const [addressList, setAddressList] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  // Repeat (new tasks only). The panel's Start Date replaces "Assign Later".
  const [repeatEnabled, setRepeatEnabled] = useState(false);
  const [repeatStart, setRepeatStart] = useState(() => new Date());
  const [repeatSettings, setRepeatSettings] = useState(() =>
    defaultRepeatSettings(new Date())
  );
  const [repeatSuccessMessage, setRepeatSuccessMessage] = useState("");
  console.log("audioFile", audioFile);

  const ln = useSelector((state) => state.allUsers.language_json);
  const use_location = useLocation();
  const loc_detail = use_location?.state?.loc_details;
  let company_infos = JSON.parse(sessionStorage.getItem("userInfo"))?.company;

  console.log("loc_detail =", loc_detail);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const getCurrentLoggedUser = async () => {
    try {
      const { data } = await authApi.get(`${GET_USER}/${userInfo._id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setLoggedUser(data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSubscriptions = async () => {
    try {
      const { data } = await authApi.get(`${MY_SUBS}/${userInfo._id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setSubscriptions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
    }
  };

  const selectedMember = teamMember
    ? teamMembersList.find(
        (item) =>
          (item.user_id?._id || item.user_id)?.toString() === teamMember?.toString()
      )
    : null;

  const selectedMemberTeamId = selectedMember?.team_id;

  // A team can hold several plans: renewing early stacks a new one that
  // starts the day after the current one ends. Judging the team by its newest
  // row alone read that not-yet-started renewal as "expired" and blocked
  // assignments until it began, although the current plan was still running.
  // Mirror the backend gate instead: active if any paid plan covers today.
  const now = new Date();
  const teamSubscriptions =
    selectedMemberTeamId && subscriptions.length > 0
      ? subscriptions.filter((sub) => {
          const subTeamId = sub.team_id;
          const teamFromLookup = sub.teams?.[0]?._id;
          return (
            sub.payment_status === "completed" &&
            (subTeamId?.toString() === selectedMemberTeamId?.toString() ||
              teamFromLookup?.toString() === selectedMemberTeamId?.toString())
          );
        })
      : [];

  const hasRunningSubscription = teamSubscriptions.some(
    (sub) =>
      new Date(sub.start_date) <= now && new Date(sub.end_date) >= now
  );

  // Shown as "active until": the furthest paid end date, so a stacked
  // renewal's period is included.
  const teamSubscription = hasRunningSubscription
    ? teamSubscriptions.reduce((latest, sub) =>
        new Date(sub.end_date) > new Date(latest.end_date) ? sub : latest
      )
    : null;

  const isSubscriptionExpired = !!teamMember && !hasRunningSubscription;

  useEffect(() => {
    getTeamMemberName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamMember, editLocation, teamMembersList]);

  useEffect(() => {
    if (loc_detail) {
      let map_link = `https://www.google.com/maps/place/@${loc_detail?.location_info?.lat},${loc_detail?.location_info?.lng}/@${loc_detail?.location_info?.lat},${loc_detail?.location_info?.lng},16z`;
      setTitle(loc_detail?.customer_name ?? null);
      setAddress(loc_detail?.address ?? null);
      setMapLocation(map_link ?? null);
      setAddressBookId(loc_detail?._id ?? null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTeamMemberName = async () => {
    if ((teamMember && teamMember !== "") || editLocation) {
      const teamMemberData = teamMembersList.find(
        (item) => (item.user_id?._id || item.user_id) === teamMember
      );
      console.log(teamMemberData);
      setTeamMemberName(teamMemberData?.name);
    }
  };

  useEffect(() => {
    getCurrentLoggedUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!loggedUser]);

  useEffect(() => {}, [audioFile]);

  useEffect(() => {
    if (loggedUser) {
      getTeamMembersData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!teamMembersList, loggedUser]);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        let company_id = company_infos?._id;
        const { data } = await authApi.get(`${ADDRESS_BOOK}/${company_id}`, {
          headers: { Authorization: getAuthorizationHeader() },
        });
        setAddressList(data.addressBook);
      } catch (error) {
        setAddressList([]);
      }
    };
    fetchLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTeamMembersData = async () => {
    try {
      const { data } = await authApi.get(
        `${TEAM_MEMBERS_LIST}/${loggedUser.company?._id || loggedUser.company}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      if (data?.length > 0) {
        setTeamMembersList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOneLocationdata = async (path) => {
    try {
      console.log(path, "path");

      const arr = path.split("/");
      const { data } = await authApi.get(
        `${LOCATION}/${arr[arr?.length - 1]}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      setEditLocation(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("/update")) {
      getOneLocationdata(path.toLowerCase());
      setUpdate(true);
    } else {
      dispatch(saveLocationList([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!editLocation]);
  useEffect(() => {
    if (editLocation) {
      console.log(editLocation.employee.user_id);
      setTitle(editLocation.title);
      setTeamMember(editLocation?.employee?.user_id);
      setDiscription(editLocation.description);
      setAddress(editLocation.address);
      setChecked(editLocation.required_confirmation);
      setImages(editLocation?.images);
      setAudioFile1(editLocation.audio_note);
      setMobileNumber(editLocation.mobile_number);

      //   // setSelectedFiles(editLocation.images);
      // if (editLocation.images && editLocation.images?.length > 0) {
      //   // setImages(editLocation?.images);
      //   // setSelectedFiles(editLocation.images);
      // }
      // else {
      // setImages();
      // setSelectedFiles();
      // }
      if (
        editLocation.location_info &&
        editLocation.location_info.lat &&
        editLocation.location_info.lng
      ) {
        setMapLocation(
          `https://www.google.com/maps/place/@${editLocation.location_info.lat},${editLocation.location_info.lng}/@${editLocation.location_info.lat},${editLocation.location_info.lng},16z`
        );
      }
    }
  }, [editLocation]);

  const handlemapLocation = (value) => {
    let data = {};

    const regex = /([-+]?\d+\.\d+),([-+]?\d+\.\d+)/;
    const match = value?.match(regex);

    if (match && match?.length === 3) {
      const extractedLatitude = parseFloat(match[1]);
      const extractedLongitude = parseFloat(match[2]);

      // Assign extracted latitude and longitude to the data object
      data.lat = extractedLatitude;
      data.lng = extractedLongitude;
    } else {
      // Handle invalid URL cases
      data.error = "This Map URL is not correct. Please enter a valid URL.";
    }

    return data; // Return latitude and longitude or an error
  };

  useEffect(() => {
    dispatch(SaveAudio());
    fetchSubscriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (showAlert) {
      const timeout = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // Change the duration (in milliseconds) as per your requirement

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showAlert]);

  const getLocationData = async () => {
    try {
      const userEntry = {};
      const { data } = await authApi.post(LOCATION, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      dispatch(saveLocationList(data));
      navigate("/location");
    } catch (error) {
      console.log(error);
    }
  };

  const closeModal = (status1, status2) => {
    console.log(status1, status2);
    setModalToggle(false);
    if (status2) {
      getLocationData();
      navigate("/location");
    }
  };
  const CreateimageArray = async (items) => {
    const filterArray1 = await items?.filter(
      (item) => !item.destination && !item.filename
    );
    const filterArray2 =
      (await items?.filter((item) => item.destination && item.filename)) || [];
    const array = filterArray1?.map(async (file) => {
      try {
        let formData = new FormData();
        formData.append("file", file);
        const { data } = await authImageApi.post(UPLOAD_IMAGE, formData, {
          headers: { Authorization: getAuthorizationHeader() },
        });
        const uploaded = data.data;
        // Use S3 URL as destination (matching mobile app pattern)
        return {
          destination: uploaded.location || uploaded.destination,
          filename: uploaded.filename || uploaded.key?.split("/").pop() || uploaded.originalname,
          originalname: uploaded.originalname,
          mimetype: uploaded.mimetype,
          size: uploaded.size,
          location: uploaded.location,
          key: uploaded.key,
        };
      } catch (err) {
        console.log("error ====> ", err);
      }
    });
    if (array && array?.length > 0) {
      const results = await Promise.all(array);
      const finalArray = [...filterArray2, ...results];
      return finalArray;
    } else {
      return [...filterArray2];
    }
    //return results;
    // setFiles([...files, ...results]);
    // dispatch(saveImageList([...files, ...results]));
  };
  const handleRepeatStartChange = (date) => {
    // Keep the weekly default in step with the date while the leader hasn't
    // picked days themselves (still just the old date's day).
    setRepeatSettings((prev) => ({
      ...prev,
      byWeekday:
        prev.byWeekday.length === 1 && prev.byWeekday[0] === repeatStart.getDay()
          ? [date.getDay()]
          : prev.byWeekday,
    }));
    setRepeatStart(date);
  };

  const isRepeating = repeatEnabled && !update && !editLocation;

  console.log("mapLocation =", mapLocation);
  const handleAssignNow = async () => {
    // A custom repeat starts on its first picked date; today means "right now".
    let repeatStartOn = null;
    if (isRepeating) {
      repeatStartOn = repeatStartDate(repeatSettings, repeatStart);
      const repeatError = validateRepeatSettings(repeatSettings, repeatStartOn);
      if (repeatError) {
        setError(repeatError);
        setShowAlert(true);
        return;
      }
    }
    const data = await handlemapLocation(mapLocation.toString());
    var Buildimages = await CreateimageArray(selectedFiles);
    if (data.error) {
      setError(data.error);
      setShowAlert(true);
    } else {
      if (teamMember) {
        const userEntry = {
          title: title,
          address: address,
          address_book_id: addressBookId,
          assigned_on: new Date(),
          description: discription,
          mobile_number: mobileNumber,
          location_info: {
            lat: data.lat,
            lng: data.lng,
          },
          required_confirmation: checked,
          audio_note: audioFile ? audioFile : audioFile1,
          assigned_to: teamMember,
          images: Buildimages,
        };
        if (isRepeating) {
          const now = moment();
          userEntry.assigned_on = moment(repeatStartOn).isSame(now, "day")
            ? now.toDate()
            : moment(repeatStartOn)
                .set({ hour: now.hour(), minute: now.minute(), second: 0 })
                .toDate();
          userEntry.recurrence = toRecurrencePayload(repeatSettings, repeatStartOn);
        }
        if (editLocation) {
          try {
            await authApi.put(
              `${LOCATION}/${editLocation._id}`,
              userEntry,
              {
                headers: { Authorization: getAuthorizationHeader() },
              }
            );
            setModalToggle(true);
            setSuccess(true);
          } catch (error) {
            setShowAlert(true);
            console.log(error);
            setError(error?.response?.data?.message);
          }
        } else {
          try {
            console.log(userEntry);
            const { data } = await authApi.post(
              `${LOCATION}/create`,
              userEntry,
              {
                headers: { Authorization: getAuthorizationHeader() },
              }
            );
            console.log(data);
            if (isRepeating) {
              setRepeatSuccessMessage(
                `${describeSettings(repeatSettings, repeatStartOn)}. Starts ${moment(
                  repeatStartOn
                ).format("ddd, D MMM YYYY")}.`
              );
            }
            setModalToggle(true);
            setSuccess(true);
          } catch (error) {
            console.log("error happens");
            setShowAlert(true);
            if (error.response) {
              // Log the response status code and data
              console.error("Response Status:", error.response.status);
              console.error("Response Data:", error.response.data);
              setError(error.response.data.message); // You can set a more specific error message here
            } else if (error.request) {
              // The request was made, but no response was received
              console.error("Request Error:", error.request);
              setError("No response from the server.");
            } else {
              // Something else happened while setting up the request
              console.error("Other Error:", error.message);
              setError("An error occurred while making the request.");
            }
          }
        }
        // getLocationData();
      } else {
        setShowAlert(true);
        setError("Please Select Team Member");
      }
    }
  };

  const handleSubmit = async () => {
    // This used to soft-delete the address book entry unless "Save to address
    // book" was ticked — a control whose false branch destroyed an already
    // saved entry, and with it that address's accumulated usage history.
    // Removing an address is what the address book's own Delete action is for.
    handleAssignNow();
  };

  const onDropFunction = (acceptedFiles) => {
    setSelectedFiles(acceptedFiles);
  };

  const handleAssignLater = async () => {
    var Buildimages =
      selectedFiles && selectedFiles?.length > 0
        ? await CreateimageArray(selectedFiles)
        : null;
    const data = await handlemapLocation(mapLocation);
    const userEntry = {
      title: title,
      address: address,
      address_book_id: addressBookId,
      assigned_on: new Date(),
      mobile_number: mobileNumber,
      description: discription,
      location_info: {
        lat: data.lat,
        lng: data.lng,
      },
      required_confirmation: checked,
      audio_note: audioFile,
      assigned_to: teamMember,
      images: Buildimages,
    };
    console.log(userEntry);
    setData(userEntry);
    setModalToggle(true);
  };
  console.log(audioFile1, "audioFile");
  return (
    <div>
      {isMapScreen ? (
        <AddressMapLoaction
          setIsMapScreen={setIsMapScreen}
          setMapLocation={setMapLocation}
          mapLocation={mapLocation}

          // setInputs={setInputs}
          // inputs={inputs}
        />
      ) : ln ? (
        <div>
          <div>
            <Box className={classes.brudCrumb} sx={{ mb: 3 }}>
              <span onClick={() => navigate(-1)}>
                <BrudCrumbBackIcon />
              </span>
              <span
                onClick={() => navigate("/location")}
                className={classes.form_lable}
                style={{ color: "#0A1F41" }}
              >
                {ln.locations}
              </span>
              <BrudCrumbNextIcon />
              <span className={classes.form_lable}>
                {editLocation ? editLocation.title : ln.assign_a_location}
              </span>
            </Box>
          </div>
          {loc_detail ? (
            <Paper className={classes.CreateTeamindex}>
              <Typography className={classes.createLocationheading1}>
                Address
              </Typography>
              <ValidatorForm useref="form" onSubmit={handleSubmit}>
                <div>
                  <div className={classes.locationTopGrid}>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.title}
                      </label>
                      <h6>
                        <b>{loc_detail?.customer_name}</b>
                      </h6>
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        Mobile Number
                      </label>
                      <h6>
                        <b>{loc_detail?.mobile_number || "n/a"}</b>
                      </h6>
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.address}
                      </label>
                      <h6>
                        <b>{loc_detail?.address ?? "n/a"}</b>
                      </h6>
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.map_location}
                      </label>
                      <a
                        href={`https://www.google.com/maps?q=${loc_detail?.location_info?.lat},${loc_detail?.location_info?.lng}`}
                        target="_blank"
                        className={classes.map_links} rel="noreferrer"
                      >
                        {mapLocation}
                      </a>
                    </Box>
                  </div>
                  <hr />
                  <Typography fontWeight={500} fontSize={"18px"} mt={4}>
                    Other Details
                  </Typography>
                  <div className={classes.locationMainGrid}>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.team_member}
                      </label>
                      <Select
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        className={classes.selectMenuDepartment}
                        fullWidth
                        MenuProps={{
                          style: {
                            height: "250px",
                          },
                        }}
                        size="small"
                        disabled={editLocation ? true : false}
                        value={
                          editLocation && editLocation.employee
                            ? editLocation.employee.user_id
                            : teamMember
                        }
                        onChange={(e) => {
                          setTeamMember(e.target.value);
                          console.log(e.target.value);
                        }}
                      >
                        {teamMembersList && teamMembersList?.length === 0 && (
                          <MenuItem value="">No Member Found</MenuItem>
                        )}
                        {teamMembersList &&
                          teamMembersList?.length > 0 &&
                          teamMembersList.map((item, index) => (
                            <MenuItem
                              className={classes.AddMemberDepMenuItem}
                              value={item.user_id}
                              key={index}
                              //onClick={(e) => setTeamMember(item.department_name)}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                      </Select>
                      <SubscriptionStatus
                        teamMember={teamMember}
                        isSubscriptionExpired={isSubscriptionExpired}
                        teamSubscription={teamSubscription}
                        onRenew={() => navigate("/subscriptions")}
                      />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.description} ({ln.optional})
                      </label>
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-multiline-static"
                        value={discription}
                        multiline
                        rows={3}
                        fullWidth
                        onChange={(e) => setDiscription(e.target.value)}
                      />
                    </Box>
                    <Box sx={{ mb: 2, mt: '25px' }}>
                      <div>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checked}
                              onChange={(e) => setChecked(e.target.checked)}
                              size="small"
                              sx={{
                                color: "rgba(0,0,0,0.54)",
                                "&.Mui-checked": { color: "#1976d2" },
                              }}
                            />
                          }
                          label={ln.required_confirmation}
                        />
                        <AboutusIcon />
                      </Box>
                    </div>
                  </Box>
                  </div>
                  {!update && !editLocation && (
                    <Box sx={{ mb: 3 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={repeatEnabled}
                            onChange={(e) => setRepeatEnabled(e.target.checked)}
                            size="small"
                            sx={{
                              color: "rgba(0,0,0,0.54)",
                              "&.Mui-checked": { color: "#1976d2" },
                            }}
                          />
                        }
                        label="Is this task supposed to repeat?"
                      />
                      {repeatEnabled && (
                        <RepeatOptions
                          value={repeatSettings}
                          onChange={setRepeatSettings}
                          startDate={repeatStart}
                          onStartDateChange={handleRepeatStartChange}
                        />
                      )}
                    </Box>
                  )}
                  <div>
                    <p
                      className={`${classes.createLocationheading1} ${classes.createLocationheading2}`}
                    >
                      {ln.add_audio_note}
                    </p>
                    <div style={{ height: "auto", marginBottom: "30px" }}>
                      <RecorderCard
                        audio={editLocation}
                        setEditLocation={setEditLocation}
                      />
                    </div>
                  </div>
                  <div>
                    <p
                      className={`${classes.createLocationheading1} ${classes.createLocationheading2}`}
                    >
                      {ln.add_images}
                    </p>
                    <div>
                      <div className={classes.DropZoneContainer}>
                        {update ? (
                          <div>
                            {images && images?.length > 0 ? (
                              <Basic
                                images={images}
                                onDropFunction={onDropFunction}
                              />
                            ) : (
                              <Basic onDropFunction={onDropFunction} />
                            )}
                          </div>
                        ) : (
                          <Basic onDropFunction={onDropFunction} />
                        )}
                        {/* <input
                  type="file"
                  onChange={(e) => console.log(e.target.files[0])}
                /> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classes.createLocationbtnsectin}>
                  {!isRepeating && (
                    <Button
                      variant="outlined"
                      onClick={() => handleAssignLater()}
                      disabled={isSubscriptionExpired}
                    >
                      {ln.assign_later}
                    </Button>
                  )}
                  <Button variant="contained" type="submit" disabled={isSubscriptionExpired}>
                    {isRepeating ? "Assign" : ln.assign_now}
                  </Button>
                </div>
              </ValidatorForm>
            </Paper>
          ) : (
            <Paper className={classes.CreateTeamindex}>
              <header
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography className={classes.createLocationheading1}>
                  {ln.assign_a_location}
                </Typography>
                <Autocomplete
                  disablePortal
                  options={addressList}
                  getOptionLabel={(opt) => opt.customer_name}
                  sx={{ width: 300 }}
                  size="small"
                  onChange={(_, val) => {
                    setTitle(val?.customer_name ?? "");
                    setAddress(val?.address ?? "");
                    setMapLocation(
                      val
                        ? `https://www.google.com/maps/place/@${val.location_info.lat},${val.location_info.lng}/@${val.location_info.lat},${val.location_info.lng},16z`
                        : ""
                    );
                    setMobileNumber(val?.mobile_number ?? "");
                    setAddressBookId(val?._id ?? null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      label="Add from customers"
                      {...params}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </header>
              <ValidatorForm useref="form" onSubmit={handleSubmit}>
                <div>
                  <div className={classes.locationMainGrid}>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.title}
                      </label>
                      <TextValidator
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="title"
                        value={title}
                        fullWidth
                        onChange={(e) => setTitle(e.target.value)}
                        size="small"
                        validators={["required"]}
                        errorMessages={["Title is required"]}
                      />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.team_member}
                      </label>
                      <Select
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        className={classes.selectMenuDepartment}
                        fullWidth
                        MenuProps={{
                          style: {
                            height: "250px",
                          },
                        }}
                        size="small"
                        value={teamMember}
                        onChange={(e) => {
                          setTeamMember(e.target.value);
                          console.log(e.target.value);
                        }}
                      >
                        {teamMembersList && teamMembersList?.length === 0 && (
                          <MenuItem value="">No Member Found</MenuItem>
                        )}
                        {teamMembersList &&
                          teamMembersList?.length > 0 &&
                          teamMembersList.map((item, index) => (
                            <MenuItem
                              className={classes.AddMemberDepMenuItem}
                              value={item.user_id._id}
                              key={index}
                              //onClick={(e) => setTeamMember(item.department_name)}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                      </Select>
                      <SubscriptionStatus
                        teamMember={teamMember}
                        isSubscriptionExpired={isSubscriptionExpired}
                        teamSubscription={teamSubscription}
                        onRenew={() => navigate("/subscriptions")}
                      />
                      {/* <Select
                        fullWidth
                        size="small"
                        value={editLocation && editLocation.employee ? editLocation.employee.user_id : teamMember}
                        onChange={(e) => { setTeamMember(e.target.value); console.log(e.target.value); }}
                        MenuProps={{ classes: { paper: classes.menuPaper } }}
                      >
                        {/* <div className={classes.CommunicationDropDownmain}> */}

                      {/* </div> */}
                      {/* </Select> */}
                      {/* <Select
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        className={classes.selectMenuDepartment}
                        fullWidth
                        MenuProps={{
                          style: {
                            height: "250px",
                          },
                        }}
                        size="small"
                        value={teamMember}
                        onChange={(e) => { setTeamMember(e.target.value); console.log(e.target.value); }}
                        validators={["required"]}
                        errorMessages={["Team Member is required"]}
                      >
                        {teamMembersList && teamMembersList?.length === 0 &&
                          <MenuItem value="">No Member Found</MenuItem>
                        }
                        {teamMembersList && teamMembersList?.length > 0 && teamMembersList.map((item) => (
                          <MenuItem
                            className={classes.AddMemberDepMenuItem}
                            value={item.user_id}
                          //onClick={(e) => setTeamMember(item.department_name)}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select> */}
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.address}&nbsp;({ln.optional})
                      </label>
                      <TextValidator
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="address"
                        value={address}
                        fullWidth
                        onChange={(e) => setAddress(e.target.value)}
                        size="small"
                      />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <label
                        htmlFor="firstNameinput"
                        className={classes.form_lable}
                      >
                        {ln.description} ({ln.optional})
                      </label>
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-multiline-static"
                        value={discription}
                        multiline
                        rows={3}
                        fullWidth
                        onChange={(e) => setDiscription(e.target.value)}
                      />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <label
                          htmlFor="firstNameinput"
                          className={classes.form_lable}
                        >
                          {ln.map_location}
                        </label>
                        <button
                          className={classes.create_lo_add_from_map}
                          onClick={() => setIsMapScreen(true)}
                          style={{ fontSize: "12px", marginBottom: "8px" }}
                          type="button"
                        >
                          Add from Map
                        </button>
                      </Box>
                      <TextValidator
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-multiline-static"
                        multiline
                        rows={3}
                        value={mapLocation}
                        fullWidth
                        onChange={(e) => setMapLocation(e.target.value)}
                        validators={["required"]}
                        errorMessages={["Google Map is required"]}
                      />
                    </Box>
                    <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <div>
                        <label
                          htmlFor="firstNameinput"
                          className={classes.form_lable}
                        >
                          {ln.mobile_number} ( optional )
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="phonenumberInput"
                          value={mobileNumber}
                          inputProps={{
                            maxLength: 10,
                          }}
                          fullWidth
                          onChange={(e) => setMobileNumber(e.target.value)}
                          size="small"
                          onKeyPress={(e) => Numeric(e)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                +91
                              </InputAdornment>
                            ),
                            // endAdornment: (
                            //   <InputAdornment position="end">
                            //     <ContactIcon />
                            //   </InputAdornment>
                            // ),
                          }}
                        />
                      </div>
                      <div>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checked}
                                onChange={(e) => setChecked(e.target.checked)}
                                size="small"
                                sx={{
                                  color: "rgba(0,0,0,0.54)",
                                  "&.Mui-checked": { color: "#1976d2" },
                                }}
                              />
                            }
                            label={ln.required_confirmation}
                          />
                          <AboutusIcon />
                        </Box>
                      </div>
                    </Box>
                  </div>
                  {!update && !editLocation && (
                    <Box sx={{ mb: 3 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={repeatEnabled}
                            onChange={(e) => setRepeatEnabled(e.target.checked)}
                            size="small"
                            sx={{
                              color: "rgba(0,0,0,0.54)",
                              "&.Mui-checked": { color: "#1976d2" },
                            }}
                          />
                        }
                        label="Is this task supposed to repeat?"
                      />
                      {repeatEnabled && (
                        <RepeatOptions
                          value={repeatSettings}
                          onChange={setRepeatSettings}
                          startDate={repeatStart}
                          onStartDateChange={handleRepeatStartChange}
                        />
                      )}
                    </Box>
                  )}
                  <div>
                    <p
                      className={`${classes.createLocationheading1} ${classes.createLocationheading2}`}
                    >
                      {ln.add_audio_note}
                    </p>
                    <div style={{ height: "auto", marginBottom: "30px" }}>
                      <RecorderCard
                        audio={editLocation}
                        setAudioFile1={setAudioFile1}
                        setEditLocation={setEditLocation}
                      />
                    </div>
                  </div>
                  <div>
                    <p
                      className={`${classes.createLocationheading1} ${classes.createLocationheading2}`}
                    >
                      {ln.add_images}
                    </p>
                    <div>
                      <div className={classes.DropZoneContainer}>
                        {update ? (
                          <div>
                            {images && images?.length > 0 ? (
                              <Basic
                                images={images}
                                onDropFunction={onDropFunction}
                              />
                            ) : (
                              <Basic onDropFunction={onDropFunction} />
                            )}
                          </div>
                        ) : (
                          <Basic onDropFunction={onDropFunction} />
                        )}
                        {/* <input
                      type="file"
                      onChange={(e) => console.log(e.target.files[0])}
                    /> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classes.createLocationbtnsectin}>
                  {!isRepeating && (
                    <Button
                      variant="outlined"
                      onClick={() => handleAssignLater()}
                      disabled={isSubscriptionExpired}
                    >
                      {ln.assign_later}
                    </Button>
                  )}
                  <Button variant="contained" type="submit" disabled={isSubscriptionExpired}>
                    {isRepeating ? "Assign" : ln.assign_now}
                  </Button>
                </div>
              </ValidatorForm>
            </Paper>
          )}
          {modalToggle ? (
            <AssignLaterModel
              closeModal={closeModal}
              UserEntry={data}
              success={success}
              editLocation={editLocation}
              title={title}
              teamMemberName={teamMemberName}
              repeatSuccessMessage={repeatSuccessMessage}
            />
          ) : null}
          {showAlert && error && (
            <AlertBox type="error" message={error} stateName={setShowAlert} />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default CreateLocation;
